import type { RouteObject } from 'react-router';
import { RequireAuth } from '@/features/auth/RequireAuth';
import { ProfilePage } from './pages/ProfilePage';

export const profileRoutes: RouteObject[] = [
  {
    element: <RequireAuth />,
    children: [{ path: 'profile', element: <ProfilePage /> }],
  },
];
